import Styles from "./video_player.module.css";
import ReactPlayer from 'react-player';
import 'video.js/dist/video-js.css';
import { Attribute, Caption, Headline, Warning } from "../../subcomponents/subcomponents";
export const VideoSection = ( props ) => {
    const { videoData: { videoLink, playerTheme,  Attributes, videoName, videoNameIcon, videoNameTheme, videoRate, videoRateIcon, videoRateTheme, warnings, warningsTheme, warningsColor, sections, captionTheme, captionColor, date } } = props;
    const { VideoSection } = Styles;
    return (
      <div className={ VideoSection }>
          <VideoPlayer 
              theme     = { playerTheme } 
              videoLink = { videoLink   }
          />
          { Attributes && <Attribute Attributes={ Attributes }/> }
          <InfoSection 
              videoName      = { videoName      }
              videoNameIcon  = { videoNameIcon  }
              videoNameTheme = { videoNameTheme }
              videoRate      = { videoRate      }
              videoRateIcon  = { videoRateIcon  }
              videoRateTheme = { videoRateTheme }
              warnings       = { warnings       }
              warningsTheme  = { warningsTheme  }
              warningsColor  = { warningsColor  }
              sections       = { sections       }
              captionTheme   = { captionTheme   }
              captionColor   = { captionColor   }
              date           = { date           }
          />
      </div>
    );
};
const InfoSection = ( props ) => {
    const { videoName, videoNameIcon, videoNameTheme, videoRate, videoRateIcon, videoRateTheme, warnings, warningsTheme, warningsColor, sections, captionTheme, captionColor, date } = props;
    const { InfoSection } = Styles;
    return (
        <div className={ InfoSection }>
            { videoName && <Headline 
                icon  = { videoNameIcon  }
                text  = { videoName      } 
                width = { 600            }
                theme = { videoNameTheme } 
            /> }
            { videoRate && <Headline 
                icon  = { videoRateIcon  } 
                text  = { videoRate      }
                width = { 600            }
                theme = { videoRateTheme } 
            /> }
            { warnings && <Warning 
                warnings = { warnings      } 
                width    = { 600           }
                theme    = { warningsTheme } 
                color    = { warningsColor } 
            /> }
            { sections && <Caption 
                date     = { date         } 
                sections = { sections     } 
                width    = { 600          }
                theme    = { captionTheme } 
                color    = { captionColor } 
            /> }
        </div>
    );
};
const VideoPlayer = ( props ) => {
    const { theme, videoLink, width } = props;
    const { VideoPlayer, ReactPlayer1 } = Styles;
    return (
        <div className={ VideoPlayer } style={{ color: theme ? theme : "#444" }}>
            <ReactPlayer 
                className = { ReactPlayer1 }
                url       = { videoLink    } 
                width     = {"100%"        }
                height    = {"100%"        }
                controls  = { true         }
                playing   = { true         }
            />
        </div>
    );
};
